import { ColorResult } from 'react-color';

export const addCallToAction = (annotation: any) => {
  const props = {
    href: '',
    target: '_blank',
  };
  if (annotation.linkType === 'Web' && annotation.url) {
    props.href = annotation.url;
  }

  if (annotation.linkType === 'Email' && annotation.email) {
    props.href = `mailto:${annotation.email}`;
    props.target = 'mail';
  }

  if (annotation.linkType === 'Phone' && annotation.phone) {
    props.href = `tel:${annotation.phone}`;
  }

  return props;
};

export const calculateHexAlpha = (color: ColorResult) => {
  const alpha = Math.floor(color.rgb.a ? color.rgb.a * 255 : 255);
  const alphaHex = alpha.toString(16).padStart(2, '0');
  return color.hex + alphaHex;
};
